/**
 * @generated SignedSource<<d23c5691b4dbb9356d3ac12ad2744721>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type EventRegistrationType = "CUSTOMER" | "GUEST" | "MEMBER";
import { FragmentRefs } from "relay-runtime";
export type NewEventDetailAttendeesListItemFragment$data = {
  readonly id: string;
  readonly registrations: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly registrant: {
          readonly firstName: string | null | undefined;
          readonly id: string;
          readonly lastName: string | null | undefined;
          readonly profileImage: {
            readonly publicId: string;
          } | null | undefined;
        } | null | undefined;
        readonly type: EventRegistrationType | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "NewEventDetailAttendeesListItemFragment";
};
export type NewEventDetailAttendeesListItemFragment$key = {
  readonly " $data"?: NewEventDetailAttendeesListItemFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"NewEventDetailAttendeesListItemFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NewEventDetailAttendeesListItemFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "EventRegistrationConnection",
      "kind": "LinkedField",
      "name": "registrations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventRegistrationEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "registrant",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Image",
                      "kind": "LinkedField",
                      "name": "profileImage",
                      "plural": false,
                      "selections": [
                        {
                          "alias": "publicId",
                          "args": null,
                          "kind": "ScalarField",
                          "name": "renderingKey",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EventSignUp",
  "abstractKey": null
};
})();

(node as any).hash = "8b510e61e4db282eef66f3afce255290";

export default node;
